import { render } from "./BlogAdobeCommerceVsMagento.vue?vue&type=template&id=b9cf1bf8"
import script from "./BlogAdobeCommerceVsMagento.vue?vue&type=script&lang=js"
export * from "./BlogAdobeCommerceVsMagento.vue?vue&type=script&lang=js"

import "./BlogAdobeCommerceVsMagento.vue?vue&type=style&index=0&id=b9cf1bf8&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__